import React, { useEffect, useRef, useState } from "react";
import { ProfileRow } from "../ProfileRow";
import { renderValue } from "../renderValueHelper";
import { useTranslation } from "@helpers/translate";
import { CopiedPopup } from "../CopiedPopup";
import CopyIcon from "@assets/icons/CopyIcon";

export const UserIdRow = ({ id, display_id }) => {
  const { __ } = useTranslation();

  const [showCopiedPopup, setShowCopiedPopup] = useState(false);

  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const showPopup = () => {
    setShowCopiedPopup(true);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setShowCopiedPopup(false);
    }, 2000);
  };

  const copyWithFallback = (value) => {
    const scrollX = window.scrollX;
    const scrollY = window.scrollY;

    const textArea = document.createElement("textarea");

    textArea.value = value;
    textArea.setAttribute("readonly", "");

    textArea.style.position = "fixed";
    textArea.style.top = "0";
    textArea.style.left = "-9999px";
    textArea.style.width = "1px";
    textArea.style.height = "1px";
    textArea.style.padding = "0";
    textArea.style.border = "0";
    textArea.style.opacity = "0";

    // Захист від автоматичного zoom у Safari.
    textArea.style.fontSize = "16px";

    document.body.appendChild(textArea);

    textArea.select();
    textArea.setSelectionRange(0, value.length);

    const copied = document.execCommand("copy");

    document.body.removeChild(textArea);

    // Повертаємо viewport у попередню позицію.
    requestAnimationFrame(() => {
      window.scrollTo(scrollX, scrollY);
    });

    return copied;
  };

  const handleCopy = async (event) => {
    if (!id) {
      return;
    }

    // Прибираємо фокус із кнопки на мобільному.
    event.currentTarget.blur();

    const value = String(id);

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(value);
      } else {
        const copied = copyWithFallback(value);

        if (!copied) {
          return;
        }
      }

      showPopup();
    } catch (error) {
      try {
        const copied = copyWithFallback(value);

        if (copied) {
          showPopup();
        }
      } catch (fallbackError) {
        // Failed to copy.
      }
    }
  };

  return (
    <ProfileRow
      label={__("profile.user_id")}
      value={renderValue(
        display_id ? String(display_id) : null,
      )}
      actions={
        <div className="user-id-row__copy-wrapper">
          <button
            type="button"
            className="profile-action__button profile-action__icon-btn user-id-row__copy-button"
            onClick={handleCopy}
            aria-label={__("common.copy")}
          >
            <CopyIcon className="profile-action__icon" />
          </button>

          <div className="user-id-row__copied-popup">
            <CopiedPopup show={showCopiedPopup} />
          </div>
        </div>
      }
    />
  );
};
